<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Frame 3">
<g id="Group 3547">
<path id="Rectangle 6281" d="M17.7399 2.67893C17.8654 2.35152 17.6236 2.00006 17.273 2.00006H14.9358C14.5216 2.00006 14.1504 2.25533 14.0021 2.64202L8.39361 17.2677C8.26805 17.5951 8.50979 17.9467 8.86047 17.9467H11.5471C11.7543 17.9467 11.9399 17.819 12.014 17.6256L17.7399 2.67893Z" fill="#9027FF" fill-opacity="0.5"/>
<path id="Rectangle 6282" d="M11.885 6.68234H8.13326L2.81812 16.5249C2.45832 17.1911 2.94081 18 3.69802 18H5.48091C5.66471 18 5.83369 17.8992 5.92096 17.7374L11.885 6.68234Z" fill="#9027FF" fill-opacity="0.5"/>
<rect id="Rectangle 6283" x="2" y="10.3038" width="3.76209" height="7.69618" rx="0.5" fill="#9027FF"/>
<rect id="Rectangle 6284" x="8.12134" y="5.9877" width="3.75779" height="11.963" rx="0.5" fill="#9027FF"/>
<rect id="Rectangle 6285" x="14.2422" y="2" width="3.75779" height="15.9507" rx="0.5" fill="#9027FF"/>
</g>
</g>
</svg>
